import request from '@/utils/request';

const PATH = '/reservation/discount/type';

export const getDiscountTypeList = () => request({
  url: PATH,
  method: 'get',
});
